export default "__VITE_ASSET__53ed4eb0__"